import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/filters-logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-622dd237"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "!w-[20px]",
  src: _imports_0
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "q-mx-sm" }, "Filters", -1))
const _hoisted_3 = {
  key: 0,
  class: "filterCounter"
}
const _hoisted_4 = { class: "q-px-xs font-gordita-medium text-[12px]" }

import IncrediButton from '@/components/common/incrediButton.vue';
import elementIds from '@/const/elementIds.json';
import { IKAgentsDrawerFilter, IKEventHub } from '@/types/injectionKeys';
import { useStore } from 'vuex';
import { computed, inject } from 'vue';
import { IKAgentsSelected } from '../../agents-table.InjectionKeys';


export default /*#__PURE__*/_defineComponent({
  __name: 'nav-bar-filter-btn',
  setup(__props) {

const store = useStore();
const eventHub = inject(IKEventHub);
const agentsFilter = inject(IKAgentsDrawerFilter);
const selectedAgents = inject(IKAgentsSelected);

const isMultipleSelection = computed(() => !!selectedAgents?.selectedAgentIds.value?.size || 0 > 1);

return (_ctx: any,_cache: any) => {
  return (!_unref(store).getters['main/leftDrawer'])
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["agents-nav-item filter border-radius-[2px]", { 'ml-0': _unref(isMultipleSelection) }])
      }, [
        _createVNode(IncrediButton, {
          class: "ibf-gordita-12-m table-upper-buttons filters-button border-radius-[2px]",
          "data-testid": _unref(elementIds).agents.AgentsFilterButton,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(eventHub)?.$emit('toggleLeftDrawer')))
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _hoisted_2,
            (_unref(agentsFilter)?.agentsLeftDrawerActiveFilters?.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(agentsFilter)?.agentsLeftDrawerActiveFilters), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data-testid"])
      ], 2))
    : _createCommentVNode("", true)
}
}

})